export default __webpack_public_path__ + "static/media/PRAKASH.bee90bd9.JPG";